export default function Impact() {
  const impacts = [
    {
      icon: 'ri-building-2-line',
      number: '廃校',
      label: '有効活用',
      description: '使われなくなった学校施設を新しい産業拠点として再生'
    },
    {
      icon: 'ri-team-line',
      number: '100+',
      label: '雇用創出',
      description: '地域に安定した雇用機会を提供し、若い世代の定着を促進'
    },
    {
      icon: 'ri-leaf-line',
      number: '90%',
      label: '環境負荷削減',
      description: '従来の養殖方法と比較して水使用量と排水を大幅に削減'
    },
    {
      icon: 'ri-funds-line',
      number: '地域経済',
      label: '活性化',
      description: '新しい産業による経済循環と地域ブランドの創出'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-[#F5F9F6]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-[#C8E6C9] mb-6">
            <i className="ri-bar-chart-box-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">地域社会への貢献</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            持続可能な地域づくりへの<br />
            具体的なインパクト
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            廃校活用プロジェクトは、地域社会に多面的な価値を提供します。<br />
            環境保全と経済発展を両立させる、新しい地域創生モデルです。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {impacts.map((impact, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl border border-[#E8F5E9] hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#2D7A3E] to-[#3D9A50] rounded-xl flex items-center justify-center mb-6">
                <i className={`${impact.icon} text-white text-2xl`}></i>
              </div>
              <p className="text-3xl font-bold text-[#2D7A3E] mb-2">{impact.number}</p>
              <p className="text-lg font-semibold text-[#1A2332] mb-3">{impact.label}</p>
              <p className="text-sm text-gray-600 leading-relaxed">{impact.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-10 shadow-lg border border-[#E8F5E9]">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E8F5E9] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-smile-line text-[#2D7A3E] text-2xl"></i>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">働く場所と住む場所</h4>
              <p className="text-sm text-gray-600">雇用と住居を同時に提供し、移住を促進</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E8F5E9] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-seedling-line text-[#2D7A3E] text-2xl"></i>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">持続可能な産業</h4>
              <p className="text-sm text-gray-600">環境に配慮した長期的な事業モデル</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E8F5E9] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-[#2D7A3E] text-2xl"></i>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">若い労働力の受け入れ</h4>
              <p className="text-sm text-gray-600">地域の高齢化課題に対する解決策</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}